<template>
  <div class="orderdetail-container">
    <div class="orderdetail-title" @click="toBack">
      <img :src="arrowLeftSvg" alt="" />
      返回
    </div>
    <div class="orderdetail-status">
      <div class="orderdetail-status-info">
        <span class="status">{{ statusStr }}</span>
        <span class="create-time">{{
          detailInfo.created_at | formatDate(false)
        }}</span>
        <span class="order-no">订单号: {{ detailInfo.order_no }}</span>
      </div>
      <div class="contact-service" @click="toShowContactDialog">联系客服</div>
    </div>
    <div class="orderdetail-flow">
      <div
        class="orderdetail-flow-item"
        v-for="(item, index) in stepList"
        :key="index"
      >
        <div style="flex: 1">{{ item }}</div>
        <div class="step-line" v-if="index !== stepList.length - 1"></div>
      </div>
    </div>
    <div class="logistics-container">
      <div class="logistics-title">物流信息</div>
      <div class="logistics-info">
        <div class="logistics-info-item">
          <div>收件人：{{ detailInfo.name }}</div>
          <div>地 址： {{ address }}</div>
          <div>手机号： {{ detailInfo.phone }}</div>
        </div>
        <div class="logistics-info-item padding">
          <div>物流跟踪信息：</div>
          <div style="font-weight: 400" v-if="!detailInfo.delivery_company">
            暂无物流信息
          </div>
          <div v-else>
            <div>发货方式：快递</div>
            <div>物流公司： {{ detailInfo.delivery_company.name }}</div>
            <div>运单号码： {{ detailInfo.delivery_no }}</div>
            <div>物流跟踪</div>
            <el-scrollbar style="height: 200px">
              <div v-for="item in deliveryLogList" :key="item.id">
                {{ `${item.time} ${item.context}` }}
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-container">
      <div class="logistics-title">订单详情</div>
      <div
        class="order-content"
        v-for="item in detailInfo.goods"
        :key="item.id"
      >
        <div class="order-info">
          <img :src="item.image.length ? item.image[0] : ''" alt="" />
          <div class="order-context">
            <div class="goods-name">
              {{ item.name }}
            </div>
            <div class="goods-category">
              {{ getSpecStr(item.spec) }}
            </div>
          </div>
        </div>
        <div class="order-price">￥{{ item.price }}</div>
        <div class="order-num">X {{ item.count }}</div>
        <div class="order-all-price">￥{{ item.price_sum }}</div>
      </div>
    </div>
    <div class="total-price">
      合计(含运费)： <span>¥{{ detailInfo.price_sum }}</span>
    </div>
    <ContactDialog v-if="isshowContact" @closeDialog="closeContactDialog" />
  </div>
</template>

<script>
import ContactDialog from "@/components/ContactDialog";
import { getDeliveryLog } from "@/api/home";
export default {
  components: { ContactDialog },
  props: {
    detailInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      arrowLeftSvg: require("@/assets/arrow-back.svg"),
      isshowContact: false,
      stepList: ["提交订单", "付款成功", "商家发货", "收货成功/交易完成"],
      deliveryLogList: [],
    };
  },
  computed: {
    address() {
      let str = "";
      if (this.detailInfo) {
        str = `${this.detailInfo.address}${this.detailInfo.city}${this.detailInfo.district}${this.detailInfo.address}`;
      }
      return str;
    },
    statusStr() {
      let str = "";
      switch (this.detailInfo.status) {
        case -1:
          str = "已取消";
          break;
        case 1:
          str = "待支付";
          break;
        case 2:
          str = "待发货";
          break;
        case 3:
          str = "待收货";
          break;
        case 4:
          str = "已完成";
          break;
      }
      return str;
    },
  },
  created() {
    if (this.detailInfo.status == 3 || this.detailInfo.status == 4) {
      this.getDeliveryLog();
    }
  },
  methods: {
    // 获取物流信息
    async getDeliveryLog() {
      const { data } = await getDeliveryLog({
        order_no: this.detailInfo.order_no,
      });
      this.deliveryLogList = data;
    },
    getSpecStr(spec) {
      let str = "";
      for (const prop in spec) {
        str = `${prop}:${spec[prop]}`;
      }
      return str;
    },
    toBack() {
      this.$emit("toBack");
    },
    closeContactDialog() {
      this.isshowContact = false;
    },
    //联系客服
    toShowContactDialog() {
      this.isshowContact = true;
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
@import "~@/styles/mixin.less";
.orderdetail-container {
  width: 100%;
}
.orderdetail-title {
  display: flex;
  align-items: center;
  margin-left: 10px;
  font-size: 20px;
  font-weight: 600;
  color: @words;
  margin-bottom: 34px;
  cursor: pointer;
  > img {
    margin-right: 13px;
  }
}
.orderdetail-status {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding-bottom: 9px;
  margin: 0 87px 0 68px;
  box-sizing: border-box;
  border-bottom: 3px solid #e3e3e3;
}
.orderdetail-status .status {
  font-size: 30px;
  font-weight: 600;
  color: @warnWords;
  margin-right: 24px;
}
.create-time,
.order-no {
  font-size: 14px;
  font-weight: 400;
  color: @tipwords;
}
.create-time {
  margin-right: 20px;
}
.contact-service {
  font-size: 14px;
  font-weight: 400;
  color: @primary;
}
.orderdetail-flow {
  margin: 48px 50px 80px 68px;
  display: flex;
  font-size: 20px;
  font-weight: 600;
  color: @darkwords;
}
.orderdetail-flow-item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.orderdetail-flow-item .step-line {
  width: 120px;
  height: 2px;
  border: 1px solid #e3e3e3;
  box-sizing: border-box;
  flex: 1;
}
.logistics-container,
.detail-container {
  margin: 0 87px 0 68px;
}
.logistics-title {
  font-size: 20px;
  font-weight: 600;
  color: @words;
  padding-bottom: 9px;
  border-bottom: 1px solid #e3e3e3;
  margin-bottom: 32px;
}
.logistics-info {
  display: flex;
}
.logistics-info-item {
  width: 50%;
  box-sizing: border-box;
  padding-bottom: 40px;
}
.logistics-info-item.padding {
  padding-left: 45px;
  box-sizing: border-box;
}
.logistics-info-item:first-child {
  border-right: 1px solid #e3e3e3;
}
.logistics-info-item div {
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 600;
  color: @words;
}
.detail-container {
  margin-top: 40px;
}
.order-content {
  margin-top: 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.order-content:last-child {
  padding-bottom: 70px;
  border-bottom: 1px solid #e3e3e3;
}
.order-info {
  display: flex;
}
.order-info img {
  width: 90px;
  height: 90px;
  object-fit: cover;
  margin-right: 26px;
}
.order-context {
  width: 321px;
}
.goods-name,
.order-num {
  font-size: 14px;
  font-weight: 600;
  color: @words;
}
.goods-name {
  .line-clamp();
}
.goods-category {
  margin-top: 21px;
  font-size: 12px;
  font-weight: 400;
  color: @tipwords;
  .line-clamp(1);
}
.order-price,
.order-all-price {
  font-size: 20px;
  font-weight: 600;
  color: @words;
}
.order-all-price {
  color: @primary;
}
.total-price {
  padding: 42px 79px 0 54px;
  float: right;
  font-size: 20px;
  font-weight: 600;
  color: @words;
  > span {
    color: @primary;
  }
}
</style>